// source: type/point_campaign.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var type_date_pb = require('../type/date_pb.js');
goog.object.extend(proto, type_date_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.type.AppliedPointCampaign', null, global);
goog.exportSymbol('proto.type.AppliedPointCampaign.PromotionDisplay', null, global);
goog.exportSymbol('proto.type.AppliedPointCampaign.PromotionDisplay.DisplayCase', null, global);
goog.exportSymbol('proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount', null, global);
goog.exportSymbol('proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier', null, global);
goog.exportSymbol('proto.type.PointCampaignPeriod', null, global);
goog.exportSymbol('proto.type.PointCampaignPromotionMethodAndTarget', null, global);
goog.exportSymbol('proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts', null, global);
goog.exportSymbol('proto.type.PointCampaignPromotionMethodAndTarget.MethodAndTargetCase', null, global);
goog.exportSymbol('proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll', null, global);
goog.exportSymbol('proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories', null, global);
goog.exportSymbol('proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint', null, global);
goog.exportSymbol('proto.type.PointCampaignPromotionTarget', null, global);
goog.exportSymbol('proto.type.PointCampaignShopScope', null, global);
goog.exportSymbol('proto.type.PointCampaignShopScope.ScopeCase', null, global);
goog.exportSymbol('proto.type.PointCampaignShopScope.TargetAll', null, global);
goog.exportSymbol('proto.type.PointCampaignShopScope.TargetShopGroup', null, global);
goog.exportSymbol('proto.type.PointCampaignShopScope.TargetShops', null, global);
goog.exportSymbol('proto.type.PointCampaignSnapshot', null, global);
goog.exportSymbol('proto.type.PointCampaignStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.PointCampaignPromotionMethodAndTarget = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.type.PointCampaignPromotionMethodAndTarget.oneofGroups_);
};
goog.inherits(proto.type.PointCampaignPromotionMethodAndTarget, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.PointCampaignPromotionMethodAndTarget.displayName = 'proto.type.PointCampaignPromotionMethodAndTarget';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.displayName = 'proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.repeatedFields_, null);
};
goog.inherits(proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.displayName = 'proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.repeatedFields_, null);
};
goog.inherits(proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.displayName = 'proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.displayName = 'proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.PointCampaignPeriod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.PointCampaignPeriod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.PointCampaignPeriod.displayName = 'proto.type.PointCampaignPeriod';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.PointCampaignShopScope = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.type.PointCampaignShopScope.oneofGroups_);
};
goog.inherits(proto.type.PointCampaignShopScope, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.PointCampaignShopScope.displayName = 'proto.type.PointCampaignShopScope';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.PointCampaignShopScope.TargetAll = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.PointCampaignShopScope.TargetAll, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.PointCampaignShopScope.TargetAll.displayName = 'proto.type.PointCampaignShopScope.TargetAll';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.PointCampaignShopScope.TargetShops = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.type.PointCampaignShopScope.TargetShops.repeatedFields_, null);
};
goog.inherits(proto.type.PointCampaignShopScope.TargetShops, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.PointCampaignShopScope.TargetShops.displayName = 'proto.type.PointCampaignShopScope.TargetShops';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.PointCampaignShopScope.TargetShopGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.PointCampaignShopScope.TargetShopGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.PointCampaignShopScope.TargetShopGroup.displayName = 'proto.type.PointCampaignShopScope.TargetShopGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.PointCampaignSnapshot = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.PointCampaignSnapshot, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.PointCampaignSnapshot.displayName = 'proto.type.PointCampaignSnapshot';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.AppliedPointCampaign = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.AppliedPointCampaign, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.AppliedPointCampaign.displayName = 'proto.type.AppliedPointCampaign';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.AppliedPointCampaign.PromotionDisplay = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.type.AppliedPointCampaign.PromotionDisplay.oneofGroups_);
};
goog.inherits(proto.type.AppliedPointCampaign.PromotionDisplay, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.AppliedPointCampaign.PromotionDisplay.displayName = 'proto.type.AppliedPointCampaign.PromotionDisplay';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.displayName = 'proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.displayName = 'proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.type.PointCampaignPromotionMethodAndTarget.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MethodAndTargetCase = {
  METHOD_AND_TARGET_NOT_SET: 0,
  MULTIPLIER_ALL: 1,
  MULTIPLIER_BY_CATEGORIES: 2,
  FIXED_AMOUNT_BY_PRODUCTS: 3
};

/**
 * @return {proto.type.PointCampaignPromotionMethodAndTarget.MethodAndTargetCase}
 */
proto.type.PointCampaignPromotionMethodAndTarget.prototype.getMethodAndTargetCase = function() {
  return /** @type {proto.type.PointCampaignPromotionMethodAndTarget.MethodAndTargetCase} */(jspb.Message.computeOneofCase(this, proto.type.PointCampaignPromotionMethodAndTarget.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.PointCampaignPromotionMethodAndTarget.prototype.toObject = function(opt_includeInstance) {
  return proto.type.PointCampaignPromotionMethodAndTarget.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignPromotionMethodAndTarget.toObject = function(includeInstance, msg) {
  var f, obj = {
    multiplierAll: (f = msg.getMultiplierAll()) && proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.toObject(includeInstance, f),
    multiplierByCategories: (f = msg.getMultiplierByCategories()) && proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.toObject(includeInstance, f),
    fixedAmountByProducts: (f = msg.getFixedAmountByProducts()) && proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of PointCampaignPromotionMethodAndTarget as accepted by the `fromObject` method.
 * @record
 */
proto.type.PointCampaignPromotionMethodAndTarget.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.multiplierAll;

  /** @type {?|undefined} */
  this.multiplierByCategories;

  /** @type {?|undefined} */
  this.fixedAmountByProducts;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget}
 */
proto.type.PointCampaignPromotionMethodAndTarget.fromObject = function(obj) {
  var msg = new proto.type.PointCampaignPromotionMethodAndTarget();
  obj.multiplierAll && jspb.Message.setWrapperField(
      msg, 1, proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.fromObject(obj.multiplierAll));
  obj.multiplierByCategories && jspb.Message.setWrapperField(
      msg, 2, proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.fromObject(obj.multiplierByCategories));
  obj.fixedAmountByProducts && jspb.Message.setWrapperField(
      msg, 3, proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.fromObject(obj.fixedAmountByProducts));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget}
 */
proto.type.PointCampaignPromotionMethodAndTarget.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.PointCampaignPromotionMethodAndTarget;
  return proto.type.PointCampaignPromotionMethodAndTarget.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget}
 */
proto.type.PointCampaignPromotionMethodAndTarget.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll;
      reader.readMessage(value,proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.deserializeBinaryFromReader);
      msg.setMultiplierAll(value);
      break;
    case 2:
      var value = new proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories;
      reader.readMessage(value,proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.deserializeBinaryFromReader);
      msg.setMultiplierByCategories(value);
      break;
    case 3:
      var value = new proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts;
      reader.readMessage(value,proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.deserializeBinaryFromReader);
      msg.setFixedAmountByProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.PointCampaignPromotionMethodAndTarget.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.PointCampaignPromotionMethodAndTarget.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignPromotionMethodAndTarget.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMultiplierAll();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.serializeBinaryToWriter
    );
  }
  f = message.getMultiplierByCategories();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.serializeBinaryToWriter
    );
  }
  f = message.getFixedAmountByProducts();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.prototype.toObject = function(opt_includeInstance) {
  return proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.toObject = function(includeInstance, msg) {
  var f, obj = {
    multiplier: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of MultiplierAll as accepted by the `fromObject` method.
 * @record
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.multiplier;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.fromObject = function(obj) {
  var msg = new proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll();
  obj.multiplier != null && jspb.Message.setField(msg, 1, obj.multiplier);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll;
  return proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMultiplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMultiplier();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 multiplier = 1;
 * @return {number}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.prototype.getMultiplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll.prototype.setMultiplier = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.prototype.toObject = function(opt_includeInstance) {
  return proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.toObject = function(includeInstance, msg) {
  var f, obj = {
    multiplier: jspb.Message.getFieldWithDefault(msg, 1, 0),
    categoryIdsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of MultiplierByCategories as accepted by the `fromObject` method.
 * @record
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.multiplier;

  /** @type {?|undefined} */
  this.categoryIdsList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.fromObject = function(obj) {
  var msg = new proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories();
  obj.multiplier != null && jspb.Message.setField(msg, 1, obj.multiplier);
  obj.categoryIdsList != null && jspb.Message.setField(msg, 2, obj.categoryIdsList);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories;
  return proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMultiplier(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategoryIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMultiplier();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getCategoryIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional int32 multiplier = 1;
 * @return {number}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.prototype.getMultiplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.prototype.setMultiplier = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * repeated string category_ids = 2;
 * @return {!Array<string>}
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.prototype.getCategoryIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.prototype.setCategoryIdsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.prototype.addCategoryIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories.prototype.clearCategoryIdsList = function() {
  return this.setCategoryIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.prototype.toObject = function(opt_includeInstance) {
  return proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.toObject = function(includeInstance, msg) {
  var f, obj = {
    productBonusPointsList: jspb.Message.toObjectList(msg.getProductBonusPointsList(),
    proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.toObject, includeInstance),
    sourceCsvPath: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of FixedAmountByProducts as accepted by the `fromObject` method.
 * @record
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.productBonusPointsList;

  /** @type {?|undefined} */
  this.sourceCsvPath;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts}
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.fromObject = function(obj) {
  var msg = new proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts();
  obj.productBonusPointsList && jspb.Message.setRepeatedWrapperField(
      msg, 1, obj.productBonusPointsList.map(
          proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.fromObject));
  obj.sourceCsvPath != null && jspb.Message.setField(msg, 2, obj.sourceCsvPath);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts}
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts;
  return proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts}
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint;
      reader.readMessage(value,proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.deserializeBinaryFromReader);
      msg.addProductBonusPoints(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceCsvPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductBonusPointsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.serializeBinaryToWriter
    );
  }
  f = message.getSourceCsvPath();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated ProductBonusPoint product_bonus_points = 1;
 * @return {!Array<!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint>}
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.prototype.getProductBonusPointsList = function() {
  return /** @type{!Array<!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint, 1));
};


/**
 * @param {!Array<!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint>} value
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts} returns this
*/
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.prototype.setProductBonusPointsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint}
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.prototype.addProductBonusPoints = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.prototype.clearProductBonusPointsList = function() {
  return this.setProductBonusPointsList([]);
};


/**
 * optional string source_csv_path = 2;
 * @return {string}
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.prototype.getSourceCsvPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts.prototype.setSourceCsvPath = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
    productId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    productName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    pointsPerItem: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of ProductBonusPoint as accepted by the `fromObject` method.
 * @record
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.productId;

  /** @type {?|undefined} */
  this.productName;

  /** @type {?|undefined} */
  this.pointsPerItem;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint}
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.fromObject = function(obj) {
  var msg = new proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint();
  obj.productId != null && jspb.Message.setField(msg, 1, obj.productId);
  obj.productName != null && jspb.Message.setField(msg, 2, obj.productName);
  obj.pointsPerItem != null && jspb.Message.setField(msg, 3, obj.pointsPerItem);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint}
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint;
  return proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint}
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductName(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPointsPerItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getProductId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getProductName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPointsPerItem();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string product_id = 1;
 * @return {string}
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.prototype.getProductId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.prototype.setProductId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string product_name = 2;
 * @return {string}
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.prototype.getProductName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.prototype.setProductName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 points_per_item = 3;
 * @return {number}
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.prototype.getPointsPerItem = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.ProductBonusPoint.prototype.setPointsPerItem = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional MultiplierAll multiplier_all = 1;
 * @return {?proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll}
 */
proto.type.PointCampaignPromotionMethodAndTarget.prototype.getMultiplierAll = function() {
  return /** @type{?proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll} */ (
    jspb.Message.getWrapperField(this, proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll, 1));
};


/**
 * @param {?proto.type.PointCampaignPromotionMethodAndTarget.MultiplierAll|undefined} value
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget} returns this
*/
proto.type.PointCampaignPromotionMethodAndTarget.prototype.setMultiplierAll = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.type.PointCampaignPromotionMethodAndTarget.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.prototype.clearMultiplierAll = function() {
  return this.setMultiplierAll(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.PointCampaignPromotionMethodAndTarget.prototype.hasMultiplierAll = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MultiplierByCategories multiplier_by_categories = 2;
 * @return {?proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories}
 */
proto.type.PointCampaignPromotionMethodAndTarget.prototype.getMultiplierByCategories = function() {
  return /** @type{?proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories} */ (
    jspb.Message.getWrapperField(this, proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories, 2));
};


/**
 * @param {?proto.type.PointCampaignPromotionMethodAndTarget.MultiplierByCategories|undefined} value
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget} returns this
*/
proto.type.PointCampaignPromotionMethodAndTarget.prototype.setMultiplierByCategories = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.type.PointCampaignPromotionMethodAndTarget.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.prototype.clearMultiplierByCategories = function() {
  return this.setMultiplierByCategories(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.PointCampaignPromotionMethodAndTarget.prototype.hasMultiplierByCategories = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional FixedAmountByProducts fixed_amount_by_products = 3;
 * @return {?proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts}
 */
proto.type.PointCampaignPromotionMethodAndTarget.prototype.getFixedAmountByProducts = function() {
  return /** @type{?proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts} */ (
    jspb.Message.getWrapperField(this, proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts, 3));
};


/**
 * @param {?proto.type.PointCampaignPromotionMethodAndTarget.FixedAmountByProducts|undefined} value
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget} returns this
*/
proto.type.PointCampaignPromotionMethodAndTarget.prototype.setFixedAmountByProducts = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.type.PointCampaignPromotionMethodAndTarget.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.PointCampaignPromotionMethodAndTarget} returns this
 */
proto.type.PointCampaignPromotionMethodAndTarget.prototype.clearFixedAmountByProducts = function() {
  return this.setFixedAmountByProducts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.PointCampaignPromotionMethodAndTarget.prototype.hasFixedAmountByProducts = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.PointCampaignPeriod.prototype.toObject = function(opt_includeInstance) {
  return proto.type.PointCampaignPeriod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.PointCampaignPeriod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignPeriod.toObject = function(includeInstance, msg) {
  var f, obj = {
    startDate: (f = msg.getStartDate()) && type_date_pb.Date.toObject(includeInstance, f),
    endDate: (f = msg.getEndDate()) && type_date_pb.Date.toObject(includeInstance, f),
    hasEndDate: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of PointCampaignPeriod as accepted by the `fromObject` method.
 * @record
 */
proto.type.PointCampaignPeriod.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.startDate;

  /** @type {?|undefined} */
  this.endDate;

  /** @type {?|undefined} */
  this.hasEndDate;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.PointCampaignPeriod.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.PointCampaignPeriod}
 */
proto.type.PointCampaignPeriod.fromObject = function(obj) {
  var msg = new proto.type.PointCampaignPeriod();
  obj.startDate && jspb.Message.setWrapperField(
      msg, 1, type_date_pb.Date.fromObject(obj.startDate));
  obj.endDate && jspb.Message.setWrapperField(
      msg, 2, type_date_pb.Date.fromObject(obj.endDate));
  obj.hasEndDate != null && jspb.Message.setField(msg, 3, obj.hasEndDate);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.PointCampaignPeriod}
 */
proto.type.PointCampaignPeriod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.PointCampaignPeriod;
  return proto.type.PointCampaignPeriod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.PointCampaignPeriod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.PointCampaignPeriod}
 */
proto.type.PointCampaignPeriod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new type_date_pb.Date;
      reader.readMessage(value,type_date_pb.Date.deserializeBinaryFromReader);
      msg.setStartDate(value);
      break;
    case 2:
      var value = new type_date_pb.Date;
      reader.readMessage(value,type_date_pb.Date.deserializeBinaryFromReader);
      msg.setEndDate(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasEndDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.PointCampaignPeriod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.PointCampaignPeriod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.PointCampaignPeriod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignPeriod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStartDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getHasEndDate();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional Date start_date = 1;
 * @return {?proto.type.Date}
 */
proto.type.PointCampaignPeriod.prototype.getStartDate = function() {
  return /** @type{?proto.type.Date} */ (
    jspb.Message.getWrapperField(this, type_date_pb.Date, 1));
};


/**
 * @param {?proto.type.Date|undefined} value
 * @return {!proto.type.PointCampaignPeriod} returns this
*/
proto.type.PointCampaignPeriod.prototype.setStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.PointCampaignPeriod} returns this
 */
proto.type.PointCampaignPeriod.prototype.clearStartDate = function() {
  return this.setStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.PointCampaignPeriod.prototype.hasStartDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Date end_date = 2;
 * @return {?proto.type.Date}
 */
proto.type.PointCampaignPeriod.prototype.getEndDate = function() {
  return /** @type{?proto.type.Date} */ (
    jspb.Message.getWrapperField(this, type_date_pb.Date, 2));
};


/**
 * @param {?proto.type.Date|undefined} value
 * @return {!proto.type.PointCampaignPeriod} returns this
*/
proto.type.PointCampaignPeriod.prototype.setEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.PointCampaignPeriod} returns this
 */
proto.type.PointCampaignPeriod.prototype.clearEndDate = function() {
  return this.setEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.PointCampaignPeriod.prototype.hasEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool has_end_date = 3;
 * @return {boolean}
 */
proto.type.PointCampaignPeriod.prototype.getHasEndDate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.type.PointCampaignPeriod} returns this
 */
proto.type.PointCampaignPeriod.prototype.setHasEndDate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.type.PointCampaignShopScope.oneofGroups_ = [[1,2,3]];

/**
 * @enum {number}
 */
proto.type.PointCampaignShopScope.ScopeCase = {
  SCOPE_NOT_SET: 0,
  TARGET_ALL: 1,
  TARGET_SHOPS: 2,
  TARGET_SHOP_GROUP: 3
};

/**
 * @return {proto.type.PointCampaignShopScope.ScopeCase}
 */
proto.type.PointCampaignShopScope.prototype.getScopeCase = function() {
  return /** @type {proto.type.PointCampaignShopScope.ScopeCase} */(jspb.Message.computeOneofCase(this, proto.type.PointCampaignShopScope.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.PointCampaignShopScope.prototype.toObject = function(opt_includeInstance) {
  return proto.type.PointCampaignShopScope.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.PointCampaignShopScope} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignShopScope.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetAll: (f = msg.getTargetAll()) && proto.type.PointCampaignShopScope.TargetAll.toObject(includeInstance, f),
    targetShops: (f = msg.getTargetShops()) && proto.type.PointCampaignShopScope.TargetShops.toObject(includeInstance, f),
    targetShopGroup: (f = msg.getTargetShopGroup()) && proto.type.PointCampaignShopScope.TargetShopGroup.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of PointCampaignShopScope as accepted by the `fromObject` method.
 * @record
 */
proto.type.PointCampaignShopScope.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.targetAll;

  /** @type {?|undefined} */
  this.targetShops;

  /** @type {?|undefined} */
  this.targetShopGroup;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.PointCampaignShopScope.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.PointCampaignShopScope}
 */
proto.type.PointCampaignShopScope.fromObject = function(obj) {
  var msg = new proto.type.PointCampaignShopScope();
  obj.targetAll && jspb.Message.setWrapperField(
      msg, 1, proto.type.PointCampaignShopScope.TargetAll.fromObject(obj.targetAll));
  obj.targetShops && jspb.Message.setWrapperField(
      msg, 2, proto.type.PointCampaignShopScope.TargetShops.fromObject(obj.targetShops));
  obj.targetShopGroup && jspb.Message.setWrapperField(
      msg, 3, proto.type.PointCampaignShopScope.TargetShopGroup.fromObject(obj.targetShopGroup));
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.PointCampaignShopScope}
 */
proto.type.PointCampaignShopScope.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.PointCampaignShopScope;
  return proto.type.PointCampaignShopScope.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.PointCampaignShopScope} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.PointCampaignShopScope}
 */
proto.type.PointCampaignShopScope.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.type.PointCampaignShopScope.TargetAll;
      reader.readMessage(value,proto.type.PointCampaignShopScope.TargetAll.deserializeBinaryFromReader);
      msg.setTargetAll(value);
      break;
    case 2:
      var value = new proto.type.PointCampaignShopScope.TargetShops;
      reader.readMessage(value,proto.type.PointCampaignShopScope.TargetShops.deserializeBinaryFromReader);
      msg.setTargetShops(value);
      break;
    case 3:
      var value = new proto.type.PointCampaignShopScope.TargetShopGroup;
      reader.readMessage(value,proto.type.PointCampaignShopScope.TargetShopGroup.deserializeBinaryFromReader);
      msg.setTargetShopGroup(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.PointCampaignShopScope.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.PointCampaignShopScope.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.PointCampaignShopScope} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignShopScope.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetAll();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.type.PointCampaignShopScope.TargetAll.serializeBinaryToWriter
    );
  }
  f = message.getTargetShops();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.type.PointCampaignShopScope.TargetShops.serializeBinaryToWriter
    );
  }
  f = message.getTargetShopGroup();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.type.PointCampaignShopScope.TargetShopGroup.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.PointCampaignShopScope.TargetAll.prototype.toObject = function(opt_includeInstance) {
  return proto.type.PointCampaignShopScope.TargetAll.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.PointCampaignShopScope.TargetAll} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignShopScope.TargetAll.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of TargetAll as accepted by the `fromObject` method.
 * @record
 */
proto.type.PointCampaignShopScope.TargetAll.ObjectFormat = function() {
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.PointCampaignShopScope.TargetAll.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.PointCampaignShopScope.TargetAll}
 */
proto.type.PointCampaignShopScope.TargetAll.fromObject = function(obj) {
  var msg = new proto.type.PointCampaignShopScope.TargetAll();
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.PointCampaignShopScope.TargetAll}
 */
proto.type.PointCampaignShopScope.TargetAll.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.PointCampaignShopScope.TargetAll;
  return proto.type.PointCampaignShopScope.TargetAll.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.PointCampaignShopScope.TargetAll} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.PointCampaignShopScope.TargetAll}
 */
proto.type.PointCampaignShopScope.TargetAll.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.PointCampaignShopScope.TargetAll.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.PointCampaignShopScope.TargetAll.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.PointCampaignShopScope.TargetAll} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignShopScope.TargetAll.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.type.PointCampaignShopScope.TargetShops.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.PointCampaignShopScope.TargetShops.prototype.toObject = function(opt_includeInstance) {
  return proto.type.PointCampaignShopScope.TargetShops.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.PointCampaignShopScope.TargetShops} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignShopScope.TargetShops.toObject = function(includeInstance, msg) {
  var f, obj = {
    shopIdsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of TargetShops as accepted by the `fromObject` method.
 * @record
 */
proto.type.PointCampaignShopScope.TargetShops.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.shopIdsList;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.PointCampaignShopScope.TargetShops.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.PointCampaignShopScope.TargetShops}
 */
proto.type.PointCampaignShopScope.TargetShops.fromObject = function(obj) {
  var msg = new proto.type.PointCampaignShopScope.TargetShops();
  obj.shopIdsList != null && jspb.Message.setField(msg, 1, obj.shopIdsList);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.PointCampaignShopScope.TargetShops}
 */
proto.type.PointCampaignShopScope.TargetShops.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.PointCampaignShopScope.TargetShops;
  return proto.type.PointCampaignShopScope.TargetShops.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.PointCampaignShopScope.TargetShops} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.PointCampaignShopScope.TargetShops}
 */
proto.type.PointCampaignShopScope.TargetShops.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addShopIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.PointCampaignShopScope.TargetShops.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.PointCampaignShopScope.TargetShops.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.PointCampaignShopScope.TargetShops} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignShopScope.TargetShops.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShopIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string shop_ids = 1;
 * @return {!Array<string>}
 */
proto.type.PointCampaignShopScope.TargetShops.prototype.getShopIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.type.PointCampaignShopScope.TargetShops} returns this
 */
proto.type.PointCampaignShopScope.TargetShops.prototype.setShopIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.type.PointCampaignShopScope.TargetShops} returns this
 */
proto.type.PointCampaignShopScope.TargetShops.prototype.addShopIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.type.PointCampaignShopScope.TargetShops} returns this
 */
proto.type.PointCampaignShopScope.TargetShops.prototype.clearShopIdsList = function() {
  return this.setShopIdsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.PointCampaignShopScope.TargetShopGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.type.PointCampaignShopScope.TargetShopGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.PointCampaignShopScope.TargetShopGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignShopScope.TargetShopGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    shopGroupId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of TargetShopGroup as accepted by the `fromObject` method.
 * @record
 */
proto.type.PointCampaignShopScope.TargetShopGroup.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.shopGroupId;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.PointCampaignShopScope.TargetShopGroup.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.PointCampaignShopScope.TargetShopGroup}
 */
proto.type.PointCampaignShopScope.TargetShopGroup.fromObject = function(obj) {
  var msg = new proto.type.PointCampaignShopScope.TargetShopGroup();
  obj.shopGroupId != null && jspb.Message.setField(msg, 1, obj.shopGroupId);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.PointCampaignShopScope.TargetShopGroup}
 */
proto.type.PointCampaignShopScope.TargetShopGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.PointCampaignShopScope.TargetShopGroup;
  return proto.type.PointCampaignShopScope.TargetShopGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.PointCampaignShopScope.TargetShopGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.PointCampaignShopScope.TargetShopGroup}
 */
proto.type.PointCampaignShopScope.TargetShopGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setShopGroupId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.PointCampaignShopScope.TargetShopGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.PointCampaignShopScope.TargetShopGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.PointCampaignShopScope.TargetShopGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignShopScope.TargetShopGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getShopGroupId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string shop_group_id = 1;
 * @return {string}
 */
proto.type.PointCampaignShopScope.TargetShopGroup.prototype.getShopGroupId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.PointCampaignShopScope.TargetShopGroup} returns this
 */
proto.type.PointCampaignShopScope.TargetShopGroup.prototype.setShopGroupId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TargetAll target_all = 1;
 * @return {?proto.type.PointCampaignShopScope.TargetAll}
 */
proto.type.PointCampaignShopScope.prototype.getTargetAll = function() {
  return /** @type{?proto.type.PointCampaignShopScope.TargetAll} */ (
    jspb.Message.getWrapperField(this, proto.type.PointCampaignShopScope.TargetAll, 1));
};


/**
 * @param {?proto.type.PointCampaignShopScope.TargetAll|undefined} value
 * @return {!proto.type.PointCampaignShopScope} returns this
*/
proto.type.PointCampaignShopScope.prototype.setTargetAll = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.type.PointCampaignShopScope.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.PointCampaignShopScope} returns this
 */
proto.type.PointCampaignShopScope.prototype.clearTargetAll = function() {
  return this.setTargetAll(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.PointCampaignShopScope.prototype.hasTargetAll = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TargetShops target_shops = 2;
 * @return {?proto.type.PointCampaignShopScope.TargetShops}
 */
proto.type.PointCampaignShopScope.prototype.getTargetShops = function() {
  return /** @type{?proto.type.PointCampaignShopScope.TargetShops} */ (
    jspb.Message.getWrapperField(this, proto.type.PointCampaignShopScope.TargetShops, 2));
};


/**
 * @param {?proto.type.PointCampaignShopScope.TargetShops|undefined} value
 * @return {!proto.type.PointCampaignShopScope} returns this
*/
proto.type.PointCampaignShopScope.prototype.setTargetShops = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.type.PointCampaignShopScope.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.PointCampaignShopScope} returns this
 */
proto.type.PointCampaignShopScope.prototype.clearTargetShops = function() {
  return this.setTargetShops(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.PointCampaignShopScope.prototype.hasTargetShops = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TargetShopGroup target_shop_group = 3;
 * @return {?proto.type.PointCampaignShopScope.TargetShopGroup}
 */
proto.type.PointCampaignShopScope.prototype.getTargetShopGroup = function() {
  return /** @type{?proto.type.PointCampaignShopScope.TargetShopGroup} */ (
    jspb.Message.getWrapperField(this, proto.type.PointCampaignShopScope.TargetShopGroup, 3));
};


/**
 * @param {?proto.type.PointCampaignShopScope.TargetShopGroup|undefined} value
 * @return {!proto.type.PointCampaignShopScope} returns this
*/
proto.type.PointCampaignShopScope.prototype.setTargetShopGroup = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.type.PointCampaignShopScope.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.PointCampaignShopScope} returns this
 */
proto.type.PointCampaignShopScope.prototype.clearTargetShopGroup = function() {
  return this.setTargetShopGroup(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.PointCampaignShopScope.prototype.hasTargetShopGroup = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.PointCampaignSnapshot.prototype.toObject = function(opt_includeInstance) {
  return proto.type.PointCampaignSnapshot.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.PointCampaignSnapshot} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignSnapshot.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pointCampaignId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdByUserId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    promotionMethodAndTarget: (f = msg.getPromotionMethodAndTarget()) && proto.type.PointCampaignPromotionMethodAndTarget.toObject(includeInstance, f),
    period: (f = msg.getPeriod()) && proto.type.PointCampaignPeriod.toObject(includeInstance, f),
    shopScope: (f = msg.getShopScope()) && proto.type.PointCampaignShopScope.toObject(includeInstance, f),
    adminName: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of PointCampaignSnapshot as accepted by the `fromObject` method.
 * @record
 */
proto.type.PointCampaignSnapshot.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.id;

  /** @type {?|undefined} */
  this.pointCampaignId;

  /** @type {?|undefined} */
  this.createdAt;

  /** @type {?|undefined} */
  this.createdByUserId;

  /** @type {?|undefined} */
  this.displayName;

  /** @type {?|undefined} */
  this.promotionMethodAndTarget;

  /** @type {?|undefined} */
  this.period;

  /** @type {?|undefined} */
  this.shopScope;

  /** @type {?|undefined} */
  this.adminName;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.PointCampaignSnapshot.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.PointCampaignSnapshot}
 */
proto.type.PointCampaignSnapshot.fromObject = function(obj) {
  var msg = new proto.type.PointCampaignSnapshot();
  obj.id != null && jspb.Message.setField(msg, 1, obj.id);
  obj.pointCampaignId != null && jspb.Message.setField(msg, 2, obj.pointCampaignId);
  obj.createdAt && jspb.Message.setWrapperField(
      msg, 3, google_protobuf_timestamp_pb.Timestamp.fromObject(obj.createdAt));
  obj.createdByUserId != null && jspb.Message.setField(msg, 4, obj.createdByUserId);
  obj.displayName != null && jspb.Message.setField(msg, 5, obj.displayName);
  obj.promotionMethodAndTarget && jspb.Message.setWrapperField(
      msg, 6, proto.type.PointCampaignPromotionMethodAndTarget.fromObject(obj.promotionMethodAndTarget));
  obj.period && jspb.Message.setWrapperField(
      msg, 7, proto.type.PointCampaignPeriod.fromObject(obj.period));
  obj.shopScope && jspb.Message.setWrapperField(
      msg, 8, proto.type.PointCampaignShopScope.fromObject(obj.shopScope));
  obj.adminName != null && jspb.Message.setField(msg, 9, obj.adminName);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.PointCampaignSnapshot}
 */
proto.type.PointCampaignSnapshot.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.PointCampaignSnapshot;
  return proto.type.PointCampaignSnapshot.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.PointCampaignSnapshot} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.PointCampaignSnapshot}
 */
proto.type.PointCampaignSnapshot.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPointCampaignId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedByUserId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 6:
      var value = new proto.type.PointCampaignPromotionMethodAndTarget;
      reader.readMessage(value,proto.type.PointCampaignPromotionMethodAndTarget.deserializeBinaryFromReader);
      msg.setPromotionMethodAndTarget(value);
      break;
    case 7:
      var value = new proto.type.PointCampaignPeriod;
      reader.readMessage(value,proto.type.PointCampaignPeriod.deserializeBinaryFromReader);
      msg.setPeriod(value);
      break;
    case 8:
      var value = new proto.type.PointCampaignShopScope;
      reader.readMessage(value,proto.type.PointCampaignShopScope.deserializeBinaryFromReader);
      msg.setShopScope(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdminName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.PointCampaignSnapshot.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.PointCampaignSnapshot.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.PointCampaignSnapshot} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.PointCampaignSnapshot.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPointCampaignId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedByUserId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPromotionMethodAndTarget();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.type.PointCampaignPromotionMethodAndTarget.serializeBinaryToWriter
    );
  }
  f = message.getPeriod();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.type.PointCampaignPeriod.serializeBinaryToWriter
    );
  }
  f = message.getShopScope();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.type.PointCampaignShopScope.serializeBinaryToWriter
    );
  }
  f = message.getAdminName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.type.PointCampaignSnapshot.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.PointCampaignSnapshot} returns this
 */
proto.type.PointCampaignSnapshot.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string point_campaign_id = 2;
 * @return {string}
 */
proto.type.PointCampaignSnapshot.prototype.getPointCampaignId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.PointCampaignSnapshot} returns this
 */
proto.type.PointCampaignSnapshot.prototype.setPointCampaignId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.type.PointCampaignSnapshot.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.type.PointCampaignSnapshot} returns this
*/
proto.type.PointCampaignSnapshot.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.PointCampaignSnapshot} returns this
 */
proto.type.PointCampaignSnapshot.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.PointCampaignSnapshot.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string created_by_user_id = 4;
 * @return {string}
 */
proto.type.PointCampaignSnapshot.prototype.getCreatedByUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.PointCampaignSnapshot} returns this
 */
proto.type.PointCampaignSnapshot.prototype.setCreatedByUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string display_name = 5;
 * @return {string}
 */
proto.type.PointCampaignSnapshot.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.PointCampaignSnapshot} returns this
 */
proto.type.PointCampaignSnapshot.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional PointCampaignPromotionMethodAndTarget promotion_method_and_target = 6;
 * @return {?proto.type.PointCampaignPromotionMethodAndTarget}
 */
proto.type.PointCampaignSnapshot.prototype.getPromotionMethodAndTarget = function() {
  return /** @type{?proto.type.PointCampaignPromotionMethodAndTarget} */ (
    jspb.Message.getWrapperField(this, proto.type.PointCampaignPromotionMethodAndTarget, 6));
};


/**
 * @param {?proto.type.PointCampaignPromotionMethodAndTarget|undefined} value
 * @return {!proto.type.PointCampaignSnapshot} returns this
*/
proto.type.PointCampaignSnapshot.prototype.setPromotionMethodAndTarget = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.PointCampaignSnapshot} returns this
 */
proto.type.PointCampaignSnapshot.prototype.clearPromotionMethodAndTarget = function() {
  return this.setPromotionMethodAndTarget(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.PointCampaignSnapshot.prototype.hasPromotionMethodAndTarget = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional PointCampaignPeriod period = 7;
 * @return {?proto.type.PointCampaignPeriod}
 */
proto.type.PointCampaignSnapshot.prototype.getPeriod = function() {
  return /** @type{?proto.type.PointCampaignPeriod} */ (
    jspb.Message.getWrapperField(this, proto.type.PointCampaignPeriod, 7));
};


/**
 * @param {?proto.type.PointCampaignPeriod|undefined} value
 * @return {!proto.type.PointCampaignSnapshot} returns this
*/
proto.type.PointCampaignSnapshot.prototype.setPeriod = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.PointCampaignSnapshot} returns this
 */
proto.type.PointCampaignSnapshot.prototype.clearPeriod = function() {
  return this.setPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.PointCampaignSnapshot.prototype.hasPeriod = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional PointCampaignShopScope shop_scope = 8;
 * @return {?proto.type.PointCampaignShopScope}
 */
proto.type.PointCampaignSnapshot.prototype.getShopScope = function() {
  return /** @type{?proto.type.PointCampaignShopScope} */ (
    jspb.Message.getWrapperField(this, proto.type.PointCampaignShopScope, 8));
};


/**
 * @param {?proto.type.PointCampaignShopScope|undefined} value
 * @return {!proto.type.PointCampaignSnapshot} returns this
*/
proto.type.PointCampaignSnapshot.prototype.setShopScope = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.PointCampaignSnapshot} returns this
 */
proto.type.PointCampaignSnapshot.prototype.clearShopScope = function() {
  return this.setShopScope(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.PointCampaignSnapshot.prototype.hasShopScope = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string admin_name = 9;
 * @return {string}
 */
proto.type.PointCampaignSnapshot.prototype.getAdminName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.PointCampaignSnapshot} returns this
 */
proto.type.PointCampaignSnapshot.prototype.setAdminName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.AppliedPointCampaign.prototype.toObject = function(opt_includeInstance) {
  return proto.type.AppliedPointCampaign.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.AppliedPointCampaign} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AppliedPointCampaign.toObject = function(includeInstance, msg) {
  var f, obj = {
    pointCampaignId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    displayName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    promotionDisplay: (f = msg.getPromotionDisplay()) && proto.type.AppliedPointCampaign.PromotionDisplay.toObject(includeInstance, f),
    period: (f = msg.getPeriod()) && proto.type.PointCampaignPeriod.toObject(includeInstance, f),
    promotionTarget: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of AppliedPointCampaign as accepted by the `fromObject` method.
 * @record
 */
proto.type.AppliedPointCampaign.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.pointCampaignId;

  /** @type {?|undefined} */
  this.displayName;

  /** @type {?|undefined} */
  this.promotionDisplay;

  /** @type {?|undefined} */
  this.period;

  /** @type {?|undefined} */
  this.promotionTarget;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.AppliedPointCampaign.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.AppliedPointCampaign}
 */
proto.type.AppliedPointCampaign.fromObject = function(obj) {
  var msg = new proto.type.AppliedPointCampaign();
  obj.pointCampaignId != null && jspb.Message.setField(msg, 1, obj.pointCampaignId);
  obj.displayName != null && jspb.Message.setField(msg, 2, obj.displayName);
  obj.promotionDisplay && jspb.Message.setWrapperField(
      msg, 3, proto.type.AppliedPointCampaign.PromotionDisplay.fromObject(obj.promotionDisplay));
  obj.period && jspb.Message.setWrapperField(
      msg, 4, proto.type.PointCampaignPeriod.fromObject(obj.period));
  obj.promotionTarget != null && jspb.Message.setField(msg, 5, obj.promotionTarget);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.AppliedPointCampaign}
 */
proto.type.AppliedPointCampaign.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.AppliedPointCampaign;
  return proto.type.AppliedPointCampaign.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.AppliedPointCampaign} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.AppliedPointCampaign}
 */
proto.type.AppliedPointCampaign.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPointCampaignId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDisplayName(value);
      break;
    case 3:
      var value = new proto.type.AppliedPointCampaign.PromotionDisplay;
      reader.readMessage(value,proto.type.AppliedPointCampaign.PromotionDisplay.deserializeBinaryFromReader);
      msg.setPromotionDisplay(value);
      break;
    case 4:
      var value = new proto.type.PointCampaignPeriod;
      reader.readMessage(value,proto.type.PointCampaignPeriod.deserializeBinaryFromReader);
      msg.setPeriod(value);
      break;
    case 5:
      var value = /** @type {!proto.type.PointCampaignPromotionTarget} */ (reader.readEnum());
      msg.setPromotionTarget(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.AppliedPointCampaign.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.AppliedPointCampaign.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.AppliedPointCampaign} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AppliedPointCampaign.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPointCampaignId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDisplayName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPromotionDisplay();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.type.AppliedPointCampaign.PromotionDisplay.serializeBinaryToWriter
    );
  }
  f = message.getPeriod();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.type.PointCampaignPeriod.serializeBinaryToWriter
    );
  }
  f = message.getPromotionTarget();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.type.AppliedPointCampaign.PromotionDisplay.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.DisplayCase = {
  DISPLAY_NOT_SET: 0,
  FIXED_AMOUNT: 1,
  MULTIPLIER: 2
};

/**
 * @return {proto.type.AppliedPointCampaign.PromotionDisplay.DisplayCase}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.getDisplayCase = function() {
  return /** @type {proto.type.AppliedPointCampaign.PromotionDisplay.DisplayCase} */(jspb.Message.computeOneofCase(this, proto.type.AppliedPointCampaign.PromotionDisplay.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.toObject = function(opt_includeInstance) {
  return proto.type.AppliedPointCampaign.PromotionDisplay.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.AppliedPointCampaign.PromotionDisplay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AppliedPointCampaign.PromotionDisplay.toObject = function(includeInstance, msg) {
  var f, obj = {
    fixedAmount: (f = msg.getFixedAmount()) && proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.toObject(includeInstance, f),
    multiplier: (f = msg.getMultiplier()) && proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.toObject(includeInstance, f),
    promotionText: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of PromotionDisplay as accepted by the `fromObject` method.
 * @record
 */
proto.type.AppliedPointCampaign.PromotionDisplay.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.fixedAmount;

  /** @type {?|undefined} */
  this.multiplier;

  /** @type {?|undefined} */
  this.promotionText;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.AppliedPointCampaign.PromotionDisplay.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.fromObject = function(obj) {
  var msg = new proto.type.AppliedPointCampaign.PromotionDisplay();
  obj.fixedAmount && jspb.Message.setWrapperField(
      msg, 1, proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.fromObject(obj.fixedAmount));
  obj.multiplier && jspb.Message.setWrapperField(
      msg, 2, proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.fromObject(obj.multiplier));
  obj.promotionText != null && jspb.Message.setField(msg, 3, obj.promotionText);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.AppliedPointCampaign.PromotionDisplay;
  return proto.type.AppliedPointCampaign.PromotionDisplay.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.AppliedPointCampaign.PromotionDisplay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount;
      reader.readMessage(value,proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.deserializeBinaryFromReader);
      msg.setFixedAmount(value);
      break;
    case 2:
      var value = new proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier;
      reader.readMessage(value,proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.deserializeBinaryFromReader);
      msg.setMultiplier(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromotionText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.AppliedPointCampaign.PromotionDisplay.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.AppliedPointCampaign.PromotionDisplay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AppliedPointCampaign.PromotionDisplay.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFixedAmount();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.serializeBinaryToWriter
    );
  }
  f = message.getMultiplier();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.serializeBinaryToWriter
    );
  }
  f = message.getPromotionText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.prototype.toObject = function(opt_includeInstance) {
  return proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.toObject = function(includeInstance, msg) {
  var f, obj = {
    pointsPerItem: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of FixedAmount as accepted by the `fromObject` method.
 * @record
 */
proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.pointsPerItem;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.fromObject = function(obj) {
  var msg = new proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount();
  obj.pointsPerItem != null && jspb.Message.setField(msg, 1, obj.pointsPerItem);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount;
  return proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPointsPerItem(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPointsPerItem();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 points_per_item = 1;
 * @return {number}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.prototype.getPointsPerItem = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount} returns this
 */
proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount.prototype.setPointsPerItem = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.prototype.toObject = function(opt_includeInstance) {
  return proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.toObject = function(includeInstance, msg) {
  var f, obj = {
    multiplier: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of Multiplier as accepted by the `fromObject` method.
 * @record
 */
proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.multiplier;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.fromObject = function(obj) {
  var msg = new proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier();
  obj.multiplier != null && jspb.Message.setField(msg, 1, obj.multiplier);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier;
  return proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMultiplier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMultiplier();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 multiplier = 1;
 * @return {number}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.prototype.getMultiplier = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier} returns this
 */
proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier.prototype.setMultiplier = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional FixedAmount fixed_amount = 1;
 * @return {?proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.getFixedAmount = function() {
  return /** @type{?proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount} */ (
    jspb.Message.getWrapperField(this, proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount, 1));
};


/**
 * @param {?proto.type.AppliedPointCampaign.PromotionDisplay.FixedAmount|undefined} value
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay} returns this
*/
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.setFixedAmount = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.type.AppliedPointCampaign.PromotionDisplay.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay} returns this
 */
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.clearFixedAmount = function() {
  return this.setFixedAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.hasFixedAmount = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Multiplier multiplier = 2;
 * @return {?proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.getMultiplier = function() {
  return /** @type{?proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier} */ (
    jspb.Message.getWrapperField(this, proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier, 2));
};


/**
 * @param {?proto.type.AppliedPointCampaign.PromotionDisplay.Multiplier|undefined} value
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay} returns this
*/
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.setMultiplier = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.type.AppliedPointCampaign.PromotionDisplay.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay} returns this
 */
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.clearMultiplier = function() {
  return this.setMultiplier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.hasMultiplier = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string promotion_text = 3;
 * @return {string}
 */
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.getPromotionText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.AppliedPointCampaign.PromotionDisplay} returns this
 */
proto.type.AppliedPointCampaign.PromotionDisplay.prototype.setPromotionText = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string point_campaign_id = 1;
 * @return {string}
 */
proto.type.AppliedPointCampaign.prototype.getPointCampaignId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.AppliedPointCampaign} returns this
 */
proto.type.AppliedPointCampaign.prototype.setPointCampaignId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string display_name = 2;
 * @return {string}
 */
proto.type.AppliedPointCampaign.prototype.getDisplayName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.AppliedPointCampaign} returns this
 */
proto.type.AppliedPointCampaign.prototype.setDisplayName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional PromotionDisplay promotion_display = 3;
 * @return {?proto.type.AppliedPointCampaign.PromotionDisplay}
 */
proto.type.AppliedPointCampaign.prototype.getPromotionDisplay = function() {
  return /** @type{?proto.type.AppliedPointCampaign.PromotionDisplay} */ (
    jspb.Message.getWrapperField(this, proto.type.AppliedPointCampaign.PromotionDisplay, 3));
};


/**
 * @param {?proto.type.AppliedPointCampaign.PromotionDisplay|undefined} value
 * @return {!proto.type.AppliedPointCampaign} returns this
*/
proto.type.AppliedPointCampaign.prototype.setPromotionDisplay = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.AppliedPointCampaign} returns this
 */
proto.type.AppliedPointCampaign.prototype.clearPromotionDisplay = function() {
  return this.setPromotionDisplay(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.AppliedPointCampaign.prototype.hasPromotionDisplay = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional PointCampaignPeriod period = 4;
 * @return {?proto.type.PointCampaignPeriod}
 */
proto.type.AppliedPointCampaign.prototype.getPeriod = function() {
  return /** @type{?proto.type.PointCampaignPeriod} */ (
    jspb.Message.getWrapperField(this, proto.type.PointCampaignPeriod, 4));
};


/**
 * @param {?proto.type.PointCampaignPeriod|undefined} value
 * @return {!proto.type.AppliedPointCampaign} returns this
*/
proto.type.AppliedPointCampaign.prototype.setPeriod = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.type.AppliedPointCampaign} returns this
 */
proto.type.AppliedPointCampaign.prototype.clearPeriod = function() {
  return this.setPeriod(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.AppliedPointCampaign.prototype.hasPeriod = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PointCampaignPromotionTarget promotion_target = 5;
 * @return {!proto.type.PointCampaignPromotionTarget}
 */
proto.type.AppliedPointCampaign.prototype.getPromotionTarget = function() {
  return /** @type {!proto.type.PointCampaignPromotionTarget} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.type.PointCampaignPromotionTarget} value
 * @return {!proto.type.AppliedPointCampaign} returns this
 */
proto.type.AppliedPointCampaign.prototype.setPromotionTarget = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * @enum {number}
 */
proto.type.PointCampaignStatus = {
  POINT_CAMPAIGN_STATUS_UNSPECIFIED: 0,
  POINT_CAMPAIGN_STATUS_DRAFT: 1,
  POINT_CAMPAIGN_STATUS_ACTIVE_BEFORE_PERIOD: 2,
  POINT_CAMPAIGN_STATUS_ACTIVE_DURING_PERIOD: 3,
  POINT_CAMPAIGN_STATUS_EXPIRED: 4,
  POINT_CAMPAIGN_STATUS_INACTIVE: 5,
  POINT_CAMPAIGN_STATUS_FORCE_TERMINATED: 6
};

/**
 * @enum {number}
 */
proto.type.PointCampaignPromotionTarget = {
  POINT_CAMPAIGN_PROMOTION_TARGET_UNSPECIFIED: 0,
  POINT_CAMPAIGN_PROMOTION_TARGET_ALL_PRODUCTS: 1,
  POINT_CAMPAIGN_PROMOTION_TARGET_BY_CATEGORIES: 2,
  POINT_CAMPAIGN_PROMOTION_TARGET_BY_PRODUCTS: 3
};

goog.object.extend(exports, proto.type);
